import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-articulos-picking',
  templateUrl: './articulos-picking.component.html',
  styleUrls: ['./articulos-picking.component.css']
})
export class ArticulosPickingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
